import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'reactstrap';
import { relativeTime } from '../../bsa/projects/projectListModel';
import { SECTION_BY_ID } from '../registry';
import { ItemControl } from '../SuperAdminAtoms';

// Products and features are tenantSettings rows too, even though they are written
// through their own endpoints.
const ROW_SOURCES = new Set(['product', 'feature', 'tenantSetting']);

const AllTenantSettings = ({ items, onJump, focusUid }) => {
  const rows = items.filter(i => ROW_SOURCES.has(i.source));
  return (
    <>
      <Alert color="info" className="mb-0" fade={false}>
        Every row from <span className="bz-mono">GET /tenantSettings</span>, edited in place. Rows no section claims yet
        are marked <strong>Unmapped</strong>, so a new migration never hides a setting.
      </Alert>
      <div className="bz-card">
        <table className="bz-table">
          <thead>
            <tr>
              <th>Setting</th>
              <th style={{ width: 90 }}>Type</th>
              <th style={{ width: 260 }}>Value</th>
              <th style={{ width: 190 }}>Shown in</th>
              <th style={{ width: 110 }}>Updated</th>
            </tr>
          </thead>
          <tbody>
            {rows.map(i => (
              <tr
                key={i.uid}
                id={`row-${i.uid}`}
                style={focusUid === i.uid ? { background: 'var(--bg-tan)' } : undefined}
              >
                <td>
                  <div style={{ fontWeight: 500 }}>{i.rawLabel || i.label}</div>
                  <div className="bz-muted bz-mono" style={{ fontSize: 'var(--fs-xs)' }}>
                    {i.id}
                  </div>
                </td>
                <td>
                  <span className="bz-pill">{i.valueType}</span>
                </td>
                <td>
                  <ItemControl item={i} withLabel />
                </td>
                <td>
                  {i.registered ? (
                    <button type="button" className="pl-linkbtn" onClick={() => onJump(i)}>
                      {SECTION_BY_ID[i.section].label}
                    </button>
                  ) : (
                    <span className="bz-pill bz-pill--warn">Unmapped</span>
                  )}
                </td>
                <td className="pl-nowrap bz-muted">{relativeTime(i.updatedAt)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};
AllTenantSettings.propTypes = {
  items: PropTypes.array.isRequired,
  onJump: PropTypes.func.isRequired,
  focusUid: PropTypes.string
};

export default AllTenantSettings;
